import { computed, reactive, ref, Ref } from 'vue'
import { Widget } from '@/models'
import { Viewer } from '@/types'

/** 附件上传 */
export default function useUpload({
  data,
  viewer
}: {
  /** 控件数据 */
  data: Ref<Widget>

  /** 文档查看 组件实例 */
  viewer: Ref<Viewer>
}) {
  /** 文件上传 input */
  const input = ref(null as HTMLInputElement | null)

  /** 加载中 */
  const loading = computed({
    set: (val: boolean) => (data.value.attachment.loading = val),
    get: () => data.value.attachment.loading
  })

  /** 处理文件上传 */
  async function handler(files: FileList) {
    const widget = data.value
    const [file] = Array.from(files)
    const { attachmentUpload: upload } = viewer.value

    if (!upload) throw '请提供 `attachmentUpload` 方法以上传附件'

    loading.value = true

    try {
      const { id, fileName } = await upload(file, widget)

      widget.value = id
      widget.attachment.fileName = fileName
    } finally {
      loading.value = false
    }
  }

  return reactive({
    input,

    /** 附件接受上传的文件类型 */
    accept: computed(() => data.value.attachment.accept || viewer.value.attachmentAccept || ''),

    /** 加载中 */
    loading,

    /** 文件名 */
    fileName: computed(() => data.value.attachment.fileName),

    /** 区域点击上传 */
    areaClick() {
      const ipt = input.value
      if (ipt) {
        ipt.value = ''
        ipt.click()
      }
    },

    /** 文件更改 */
    fileChange(e: Event) {
      handler((e.target as HTMLInputElement).files as FileList)
    },

    /** 文件拖拽 */
    fileDrop(e: DragEvent) {
      handler(e.dataTransfer?.files as FileList)
    }
  })
}
